import type { ThemeTokens } from '@course-authoring/shared-types';

/**
 * Standard width for interactive content blocks (Click Expand, Stylized Callout, etc.)
 * Inlined as part of the Phase 4 component-token flatten — these widths are
 * component-specific layout (not part of the design-system token set).
 *
 * Kept here so every interactive block uses the same value.
 */
const STANDARD_INTERACTION_WIDTH = {
  desktop: '80%',
  mobile: '90%',
} as const;

export function getStandardInteractionWidth(
  _tokens: ThemeTokens,
  isMobile: boolean
): string {
  return isMobile ? STANDARD_INTERACTION_WIDTH.mobile : STANDARD_INTERACTION_WIDTH.desktop;
}
